<table class="table-skeleton w-100">
    <thead>
        <tr>
            <th *ngFor="let col of columnArray">
                <div class="skeleton-cell skeleton-header"></div>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of rowArray">
            <td *ngFor="let col of columnArray">
                <div class="skeleton-cell"></div>
            </td>
        </tr>
    </tbody>
</table>
